import {
  Box,
  Typography,
  Button,
  Paper,
  Container,
  Divider,
  Grid2,
  useMediaQuery
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LockIcon from '@mui/icons-material/Lock';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useTheme } from '@mui/material/styles';
import ActionButton from '../../../core/components/ui/ActionButton';

const EnrollmentWelcome = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'));
  const isExtraLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  
  const expectationItems = [
    {
      icon: <CheckCircleOutlineIcon sx={{ fontSize: 40, color: theme.palette.success.main }} />,
      title: 'Basic Information',
      description: `We’ll ask for some basic details to get started`
    },
    {
      icon: <AccessTimeIcon sx={{ fontSize: 40, color: theme.palette.secondary.main }} />,
      title: 'Quick Review',
      description: 'Our team will review your enrollment within 3 business days'
    },
    {
      icon: <LockIcon sx={{ fontSize: 40, color: '#9C27B0' }} />,
      title: 'Safe & Secure',
      description: 'Your information is protected and kept confidential'
    }
  ];
  
  return (
    <Box
      sx={{
        padding: '0px',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: theme.palette.background.default,
        pt: 0,
        pb: 8
      }}
    >
      <Container
        maxWidth={isExtraLargeScreen ? "lg" : (isLargeScreen ? "md" : "sm")}
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Paper
          elevation={1}
          sx={{
            p: { xs: 3, sm: 4, md: 5 },
            pb: { md: 4 },
            borderRadius: '12px',
            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1
          }}
        >
          <Box sx={{ textAlign: 'center', mb: { xs: 4, md: 5 } }}>
            <Typography
              variant={isLargeScreen ? "h2" : "h3"}
              component="h1"
              color={theme.palette.primary[800]}
              sx={{
                mb: 2,
                fontWeight: 600,
                // background: `linear-gradient(45deg, ${theme.palette.primary.main} 30%, ${theme.palette.secondary.main} 90%)`,
                // WebkitBackgroundClip: 'text',
                // WebkitTextFillColor: 'transparent'

              }}
            >
              Welcome to MindRight Health! 👋
            </Typography>
            <Typography
              variant={isLargeScreen ? "h6" : "body1"}
              color="text.secondary"
              sx={{
                maxWidth: '700px',
                mx: 'auto',
                lineHeight: 1.6
              }}
            >
              {`Let’s set up your membership profile. This should take about 5 minutes.`}
            </Typography>
          </Box>

          <Box sx={{ mb: 4, flexGrow: 1 }}>
            <Typography
              variant="h5"
              sx={{
                mb: { xs: 3, md: 4 },
                textAlign: isLargeScreen ? 'center' : 'left',
                fontWeight: 600
              }}
            >
              What to expect:
            </Typography>

            <Grid2 container spacing={isLargeScreen ? 4 : 3}>
              {expectationItems.map((item, index) => (
                <Grid2 size={{ xs: 12, md: 4 }} key={index}>
                  <Paper
                    elevation={0}
                    sx={{
                      p: 3,
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      textAlign: 'center',
                      borderRadius: '8px',
                      backgroundColor: theme.palette.background.paper,
                      border: `1px solid ${theme.palette.divider}`,
                      transition: 'transform 0.3s, box-shadow 0.3s',
                      '&:hover': {
                        transform: 'translateY(-5px)',
                        boxShadow: '0 10px 20px rgba(0,0,0,0.1)'
                      }
                    }}
                  >
                    <Box sx={{ mb: 2 }}>
                      {item.icon}
                    </Box>
                    <Typography variant="h6" sx={{ mb: 1, fontWeight: 500 }} color={theme.palette.primary[800]}>
                      {item.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {item.description}
                    </Typography>
                  </Paper>
                </Grid2>
              ))}
            </Grid2>
          </Box>

          <Divider sx={{ mb: { xs: 3, md: 4 } }} />

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              // mt: { xs: 2, md: 3 },
              alignSelf: 'center'
            }}
          >
            <ActionButton text='Start Enrollment' onClick={() => navigate('/enrollment', { replace: true })}
              sx={{
                py: { xs: 1.5, md: 2 },
                px: { xs: 4, md: 6 },
                fontSize: { xs: '1rem', md: '1.125rem' },
                borderRadius: '8px',
                boxShadow: theme.shadows[4],
                minWidth: { xs: '100%', sm: '300px' }
              }} endIcon={<ArrowForwardIcon />}
              variant="contained" />
          </Box>
        </Paper>

        {isLargeScreen && (
          <Box sx={{ textAlign: 'center', mt: 3, opacity: 0.8 }}>
            <Typography variant="body2" color="text.secondary">
              MindRight has completely transformed my approach to mental wellness. - Sarah K.
            </Typography>
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default EnrollmentWelcome;